/*******************************************************************************
 * Project：
 * Summary:
 *　　 Define Role Guard Service
 * Remarks:
 *
 * History：
 *      NghiaNX            2021/04/28    Create
 ******************************************************************************/
import { Injectable } from '@angular/core';
import {
    Router,
    CanActivate,
    ActivatedRouteSnapshot
} from '@angular/router';
import { AuthenticationService } from '../service/authentication.service';
import { Utility } from 'src/app/shared/utility/utility';
@Injectable()
export class RoleGuardService implements CanActivate {
    constructor(public auth: AuthenticationService, public router: Router, private util: Utility) { }
    canActivate(route: ActivatedRouteSnapshot): boolean {
        this.auth.GetToken().subscribe(data => {
            if (this.util.isNullOrEmpty(data)){
                const strPath = route.routeConfig.path;
                if (strPath === 'insurance-sel') {
                    const strHtorgcode = route.queryParams.htorgcode;
                    this.auth.ClearData();
                    this.router.navigate([''], {
                        queryParams: {
                            continue: 'insurance-sel',
                            htorgcode: strHtorgcode,
                        }
                    });
                }
                else if (strPath === '') {
                    const strHtorgcode = route.queryParams.htorgcode;
                    const strConsulday = route.queryParams.consulday;
                    const strConsulnum = route.queryParams.consulnum;
                    this.auth.ClearData();
                    this.router.navigate([''], {
                        queryParams: {
                            htorgcode: strHtorgcode,
                            consulday: strConsulday,
                            consulnum: strConsulnum,
                        }
                    });
                }
                else {
                    this.auth.ClearData();
                    this.router.navigate(['']);
                }
            }
            else{
                this.auth.SetData(data);
            }
        }, err => {
            this.auth.logout();
        });
        return true;
    }
}
